import React from 'react';
import './IncomingRequests.css';

const IncomingRequests = ({ incomingRequests, users, handleAcceptRequest, handleRejectRequest }) => (
  incomingRequests.length > 0 && (
    <div className="incoming-requests">
      <h3>Incoming Connection Requests</h3>
      <ul>
        {incomingRequests.map(req => {
          const requester = users.find(u => u.id === req.user_id);
          return (
            <li key={req.id} className="incoming-request-item">
              <span>
                {requester ? requester.name : 'User'} wants to connect.
              </span>
              <button onClick={() => handleAcceptRequest(req)}>Accept</button>
              <button onClick={() => handleRejectRequest(req)}>Reject</button>
            </li>
          );
        })}
      </ul>
    </div>
  )
);

export default IncomingRequests;